/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import {useEffect, useState, useMemo, useRef} from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import Header from '../../components/header'
import Layout from '../../components/layout'
import style from '../../components/signup.module.css'
import LoginForm from '../../components/loginForm'
import utils from '../../components/utils'
import consts from '../../components/consts'
import CustomizeSectionsSmall from '../../components/customizeSectionsSmall'
import CustomPagePreview from '../../components/customPagePreview';
import LoaderOverlay from '../../components/loaderOverlay';

import { useStateValue } from '../../state';
import { useGetTemplates } from '../../components/useGetTemplates'
import { usePublishTemplates } from '../../components/usePublishTemplates'
import Stepper from '../../components/stepper'
import StyledToolTip from '../../components/styledToolTip'
import restUtils from '../../components/restUtils'
import config from '../../components/config'

export default function Signup() {
  const FILL_DETAILS_STEP = 'fill-details-step';
  const WORK_TYPE_QUESTION_STEP = 'work-type-question-step';
  const VERIFY_CODE_STEP = 'verify-code-step';
  const ADD_BRAND_STEP = 'add-brand-step';
  const PREVIEW_BRAND_STEP = 'preview-brand-step';
  const ADD_BRAND_CTA = 'add-brand-cta';
  const workTypes = ['Technology','Design', 'Architecture', 'Education', 'Marketing', 'Finance', 'Consulting', 'Health', 'Travel', 'Photography', 'Music', 'E-commerce'];
  const SHOW_STEPPER = false;

  const [
    {siteTemplate, emailTemplate, user, loading},
    dispatch
  ] = useStateValue();

  const router = useRouter();

  const [selectedAnswer, updateSelectedAnswer] = useState("");
  const [isFirstMount, updateIsFirstMount] = useState(true);
  const [currentViewState, updateCurrentViewsState] = useState(FILL_DETAILS_STEP);
  const [acceptedTerms, updateAcceptedTerms] = useState(false);
  const [missingCompanyInfo, updateMissingCompanyInfo] = useState(false);
  const [previewSnapshotBlob, updatePreviewSnapshotBlob] = useState(null);
  const [steps, updateSteps] = useState([{text: 'Signup', currentStep: true, viewState: [FILL_DETAILS_STEP, VERIFY_CODE_STEP]}, {text: 'Add Info', currentStep: false, viewState: [WORK_TYPE_QUESTION_STEP]}, {text: 'Send files!', currentStep: false, viewState: [ADD_BRAND_CTA, ADD_BRAND_STEP, PREVIEW_BRAND_STEP]}]);
  const [showOptionalPageInfo, updateShowOptionalPageInfo] = useState(false);
  const [previewSnapshotScreenshotImage, updatePreviewSnapshotScreenshotImage] = useState(null);
  const [showSignupNoteTooltip, updateShowSignupNoteTooltip] = useState(false);
  const [workTypeSelectedOptions, updateWorkTypeSelectedOptions] = useState([]);
  const [otherWorkTypeText, updateOtherWorkTypeText] = useState(null);

  const wrapperRef = useRef(null);
  const signupNoteRef = useRef(null);

 useEffect(() => {
 if(isFirstMount) {
  updateIsFirstMount(false);
  utils.trackPageView(`signup-source;${router.query["source"]}`);
  utils.reportGoogleAnalyticsConversion(consts.GA_CONVERSION_TYPES.SIGNUP_VISIT);
 }
 }, [])

 useEffect(() => {
   if(currentViewState !== FILL_DETAILS_STEP) {
    history.pushState({}, '');
    window.onpopstate = function(event) {
      switch (currentViewState) {
        case VERIFY_CODE_STEP:
          updateCurrentViewsState(FILL_DETAILS_STEP)
          break;
        case ADD_BRAND_STEP:
            updateCurrentViewsState(ADD_BRAND_CTA)
            break;
        case PREVIEW_BRAND_STEP:
          updateCurrentViewsState(ADD_BRAND_STEP)
          break;
        case ADD_BRAND_CTA:
          updateCurrentViewsState(WORK_TYPE_QUESTION_STEP)
          break;
        default:
          break;
      }
    //updateCurrentViewsState(ADD_BRAND_STEP)
    };
   //router && updateSelectedAnswer(router.query["type"]);
   }
  })

 /* useEffect(() => {
    switch (selectedAnswer.value) {
     /* case 'personal':
        utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 1, 7);
        utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, false, 7);
        break;
      case 'personal':  //Uncomment code below if we want to return to free and paid package separation between personal and business
      case 'work':
        utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 2, 7);
        utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, true, 7);
        break;
      default:
        break;
    }
    }, [selectedAnswer])*/

    /*useEffect(() => {
      if(router) {
        if(router.query['completeOnboarding'] === 'true') {
          updateCurrentViewsState(WORK_TYPE_QUESTION_STEP);
        } 
        switch (router.query["packageId"]) {
           case '1':
             utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 1, 7);
             utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, false, 7);
             break;
           case '2':
             utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 2, 7);
             utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, true, 7);
             break;
           default:
            utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PACKAGE_ID, 1, 7);
            utils.setLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage, true, 7);
             break;
         }
      }
      }, [router])*/

    useEffect(() => {
      //update current state according to view state
      let updatedSteps = steps && steps.length > 0 && steps.map(step => {
          if(!step.viewState.includes(currentViewState)) {
            step.currentStep = false
          } else {
            step.currentStep = true;
          }
          return step; 
      })
      updateSteps(updatedSteps);
    }, [currentViewState])

    useEffect(() => {
      listenToOutsideClicks(wrapperRef, () =>   updateShowOptionalPageInfo(false));
  }, [wrapperRef]);

  useEffect(() => {
    listenToOutsideClicks(signupNoteRef, () =>  updateShowSignupNoteTooltip(false));
}, [signupNoteRef]);

function listenToOutsideClicks(ref, onOutsideClick) {
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      onOutsideClick && onOutsideClick();
    }
}
// Bind the event listener
document.addEventListener("mousedown", handleClickOutside);
return () => {
    // Unbind the event listener on clean up
    document.removeEventListener("mousedown", handleClickOutside);
};
}

  function renderAnswerCircleOption(colorFill, colorStroke, answer){
    return(
      <svg onClick={() => updateSelectedAnswer(answer)} tabIndex={0} className={style.answerOption} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="8" cy="8" r="7.5" stroke={colorStroke}/>
      <circle cx="8" cy="8" r="6" fill={colorFill}/>
      </svg>
    );
  }

    function renderAnswerItem(){
      const answers = [{text: 'Work', value: 'work'}, {text:'Personal things', value: 'personal'}]
      return (
        <div className={style.answersItemsContainer}>
          {answers.map((answer) => {
            let a = answer;
            let colorFill = selectedAnswer && selectedAnswer.text === a.text ? '#13BCB4' : 'white';
            let colorStroke = selectedAnswer && selectedAnswer.text === a.text ? '#13BCB4' : '#C4C4C4';
            return <div className={style.answerItem} key={a.text}>
              {renderAnswerCircleOption(colorFill,colorStroke, a)}
              <span className={style.answerText}>{a.text}</span>
            </div>})}
        </div>
      );
    }

    function renderAccountTypeQuestion() {
      return (
        <div className={style.accountTypeQuestionContainer}>
            <span className={style.accountTypeQuestionText}>This profile is going to be used for:</span>
            {renderAnswerItem()}
        </div>
      );
    }

    function renderEmptyCheckbox(onCheckboxClick){
      return(
          <svg tabIndex={0} style={{cursor: 'pointer', outline: 'none'}} onClick={onCheckboxClick} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <rect x="0.5" y="0.5" width="14" height="14" rx="0.7" stroke="#C4C4C4"/>
          </svg>
      );
    }

    function renderSelectedCheckbox(onSelectedCheckboxClick){
      return(
          <svg style={{cursor: 'pointer', outline: 'none'}} onClick={onSelectedCheckboxClick} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M13.3333 0H1.66667C0.741667 0 0 0.75 0 1.66667V13.3333C0 14.25 0.741667 15 1.66667 15H13.3333C14.2583 15 15 14.25 15 13.3333V1.66667C15 0.75 14.2583 0 13.3333 0ZM5.83333 11.6667L1.66667 7.5L2.84167 6.325L5.83333 9.30833L12.1583 2.98333L13.3333 4.16667L5.83333 11.6667Z" fill="#13BCB4"/>
          </svg>
      );
    }

    function renderAcceptTerms() {
            return (
              <div className={style.checkboxAnswersItemsContainer}>
               <div className={style.answerItem}>
                    {acceptedTerms ? renderSelectedCheckbox(() => updateAcceptedTerms(false)) : renderEmptyCheckbox(() => updateAcceptedTerms(true))}
                    <span className={style.answerText}>I accept the <Link href='/posts/terms'><a target="_blank" rel="noopener noreferrer" className={style.termsLink}>terms and conditions</a></Link></span>
                  </div>
              </div>
            );
    }

    async function completeSignup(isFirstSignup) {
      if(isFirstSignup) {
        utils.setSessionStorageItem(consts.SESSION_STORAGE_KEYS.NEW_SIGNUP, true); 
      }
      window.location.assign('/');
   /* let isPaidPackage =  utils.getLocalStorageItem(consts.SELECTED_PACKAGE.PaidPackage);
    if(isPaidPackage) {
      updateCurrentViewsState(WORK_TYPE_QUESTION_STEP);
    } else {
      window.location.assign('/');
    }*/
       // dispatch({ type: 'LOADING-CHANGED', payload: true}); 
       // await publishTemplates(previewSnapshotBlob);
       // window.location.assign('/');
    }

    function getHeaderTextByStep() {
      switch (currentViewState) {
        case FILL_DETAILS_STEP:
        case VERIFY_CODE_STEP:  
            return 'Free Sign Up';
        case WORK_TYPE_QUESTION_STEP:
            return "Let's get started"
        case ADD_BRAND_STEP:
        case PREVIEW_BRAND_STEP:
          return 'Customize Your Page';   
        case ADD_BRAND_CTA:
          return 'Congratulations!'       
        default:
          break;
      }
    }

    function getDescriptionTextByStep() {
      switch (currentViewState) {
        case FILL_DETAILS_STEP:
           return <span>Please enter your details and we <br/> will send you a code to sign up:</span>;
       // return <span>Nice! You are 2 clicks away from your page. <br/> Signup and start sending branded transfers.</span>;
            case VERIFY_CODE_STEP:
          return 'Check your email';
        case ADD_BRAND_STEP:
          return "Add your page title and color";
        case PREVIEW_BRAND_STEP:
          return <div>Pro Tip:  <span onClick={() => updateShowOptionalPageInfo(true)} className={style.addCompanyInfo}>Click here</span> to add tagline and description</div>;
          case WORK_TYPE_QUESTION_STEP:  
          return "Help us customize your experience";
        default:
          break;
      }
    }

    function getDescriptionClassByStep() {
      switch (currentViewState) {
        case FILL_DETAILS_STEP:
        case WORK_TYPE_QUESTION_STEP:
        case VERIFY_CODE_STEP:
          return style.signupDescription;
        case ADD_BRAND_STEP: 
        return style.addBrandDescription;
        case PREVIEW_BRAND_STEP:
          return style.previewBrandDescription;
        default:
          break;
      }
    }

    async function publishTemplates(previewSnapshotBlob) {
      let templates = await useGetTemplates(dispatch);
      siteTemplate.id = templates.find(t => t.type === 'site').id;
      emailTemplate.id = templates.find(t => t.type === 'email').id;
      let success = await usePublishTemplates(siteTemplate, emailTemplate, user.userId, previewSnapshotBlob);
      if(success) {
        dispatch({ type: 'LOADING-CHANGED', payload: false}); 
      }
    }

     async function onSignupCompletionClick() {
      let eventData = {from_step: PREVIEW_BRAND_STEP, to_step: FILL_DETAILS_STEP, user_email: '', is_work_email: false};
      utils.trackFormStepChanged(eventData);

    dispatch({ type: 'LOADING-CHANGED', payload: true}); 
    let divToRemove = document.getElementById("changeCoverImageOnHover");
    if(divToRemove) {
      divToRemove.remove();
    }
      let previewSnapshotBlob = await utils.generateBrandPreviewSnapshot();
      //updatePreviewSnapshotBlob(previewSnapshotBlob);
      await publishTemplates(previewSnapshotBlob);
      //updateCurrentViewsState(FILL_DETAILS_STEP);
      await restUtils.post('completeOnboarding', null, true, config.NETWORK_REQUEST_TIME_OUT);
      dispatch({ type: 'LOADING-CHANGED', payload: false}); 
      window.location.assign('/');
    }

    function renderCompletionFooter() {
      return (
        <div className={style.completionFooterContainer}>
          <button onClick={onSignupCompletionClick} disable={loading} className={loading ? style.completeButtonDisabled : style.completeButton}>
          Done
          </button>
          <span className={style.completionNote}>You can always edit your brand in The Editor</span>
        </div>
      );
    }

    async function onBrandSave({missingInfo}) {
      let eventData = {from_step: ADD_BRAND_STEP, to_step: PREVIEW_BRAND_STEP, user_email: '', is_work_email: false};
      utils.trackFormStepChanged(eventData);
      updateMissingCompanyInfo(missingInfo);
      updateCurrentViewsState(PREVIEW_BRAND_STEP);
    }

    const renderCustomizeSectionsSmall = () => {
      return <CustomizeSectionsSmall onSave={onBrandSave} onSkip={() => updateCurrentViewsState(FILL_DETAILS_STEP)} hideSkip hideOptionalFields
      ChangeBackgroundButtonStyle={{filter: 'unset', marginTop: '0', height: '42px', borderRadius: '3.5px', border: '1.25461px solid #E1E1E1', marginBottom: '18px', width: '293px'}}
      /> 
    }

    function loadPreview() {
      var reader = new FileReader();
      reader.onloadend = function(){
        updatePreviewSnapshotScreenshotImage(reader.result);
      }
      reader.readAsDataURL(previewSnapshotBlob); 
    }

    function renderPreviewBadge() {
      return (
        <svg className={style.previewBadge} id={'previewBadge'} xmlns="http://www.w3.org/2000/svg" width="121" height="121" viewBox="0 0 121 121" fill="none">
        <path d="M120.999 120.999L0 0.016171L0.0161728 0H42.9712C45.3062 0 47.5482 0.927808 49.1978 2.57927L118.42 71.793C120.071 73.4444 120.999 75.6841 120.999 78.0188V120.999Z" fill="#117CDE"/>
        <path d="M56.4642 31.0975C56.1896 31.3721 55.866 31.5633 55.4934 31.6711C55.1257 31.7839 54.7286 31.7741 54.3021 31.6417C53.8805 31.5142 53.4589 31.2397 53.0372 30.8181L52.1768 29.9577L50.206 31.9285L49.1764 30.899L54.3095 25.7659L56.1994 27.6559C56.5965 28.053 56.8662 28.4599 57.0083 28.8766C57.1505 29.2933 57.1701 29.6905 57.0672 30.068C56.9691 30.4504 56.7681 30.7935 56.4642 31.0975ZM53.8241 29.9429C54.1085 30.2273 54.383 30.3744 54.6477 30.3842C54.9174 30.3891 55.1699 30.2739 55.4052 30.0385C55.9053 29.5385 55.8758 29.009 55.3169 28.4501L54.5007 27.6338L53.0078 29.1267L53.8241 29.9429ZM55.5951 33.2142C56.0069 32.8023 56.4531 32.518 56.9335 32.3611C57.4189 32.2091 57.8871 32.1871 58.3381 32.2949C58.7941 32.4077 59.1961 32.6381 59.5442 32.9862C59.8481 33.2901 60.0516 33.6162 60.1545 33.9643C60.2624 34.3172 60.2918 34.6555 60.2428 34.9791L60.8238 34.3981L61.8607 35.435L57.7866 39.5091L56.7497 38.4722L57.3454 37.8765C57.0218 37.9354 56.6786 37.9109 56.3158 37.803C55.9628 37.6951 55.6343 37.4892 55.3304 37.1853C54.9872 36.8421 54.7617 36.4401 54.6538 35.9792C54.5509 35.5233 54.5754 35.0526 54.7274 34.5673C54.8891 34.0819 55.1784 33.6309 55.5951 33.2142ZM58.7867 36.4352C59.0368 36.1851 59.201 35.9228 59.2794 35.6483C59.3628 35.3689 59.3677 35.0992 59.2941 34.8394C59.2255 34.5746 59.0956 34.3467 58.9044 34.1555C58.7132 33.9643 58.4901 33.8343 58.2352 33.7657C57.9802 33.6971 57.7106 33.702 57.4262 33.7804C57.1517 33.8589 56.8919 34.0206 56.6467 34.2658C56.4016 34.5109 56.2349 34.7756 56.1467 35.06C56.0682 35.3443 56.0609 35.6164 56.1246 35.8763C56.1932 36.141 56.3207 36.3665 56.507 36.5528C56.6982 36.744 56.9237 36.8764 57.1836 36.9499C57.4483 37.0186 57.718 37.0137 57.9925 36.9352C58.2719 36.8519 58.5367 36.6852 58.7867 36.4352ZM64.6857 38.1278C64.9897 38.4317 65.1956 38.7602 65.3035 39.1132C65.4162 39.4613 65.4432 39.7971 65.3844 40.1207L65.9653 39.5397L67.0022 40.5766L62.8988 44.6801C62.5212 45.0576 62.1094 45.3174 61.6633 45.4596C61.2123 45.6067 60.749 45.614 60.2734 45.4817C59.793 45.3542 59.337 45.0748 58.9056 44.6433C58.3271 44.0648 57.9863 43.4544 57.8834 42.8122C57.7853 42.1749 57.9447 41.5988 58.3614 41.084L59.3836 42.1062C59.2512 42.3465 59.2193 42.6087 59.288 42.8931C59.3566 43.1873 59.5184 43.4618 59.7733 43.7167C60.0724 44.0158 60.4058 44.1678 60.7735 44.1727C61.1363 44.1825 61.4991 44.006 61.8618 43.6432L62.4943 43.0108C62.1707 43.0696 61.8275 43.0451 61.4647 42.9372C61.1068 42.8343 60.7784 42.6333 60.4793 42.3342C60.1361 41.991 59.9106 41.589 59.8028 41.1282C59.6949 40.6673 59.717 40.1942 59.8689 39.7089C60.0307 39.2235 60.32 38.7725 60.7367 38.3557C61.1485 37.9439 61.5947 37.6596 62.0751 37.5027C62.5605 37.3507 63.0287 37.3286 63.4797 37.4365C63.9357 37.5493 64.3377 37.7797 64.6857 38.1278ZM63.9283 41.5767C64.1783 41.3267 64.3426 41.0644 64.421 40.7899C64.5044 40.5104 64.5093 40.2408 64.4357 39.981C64.3671 39.7162 64.2372 39.4882 64.046 39.297C63.8548 39.1058 63.6317 38.9759 63.3768 38.9073C63.1218 38.8386 62.8522 38.8435 62.5678 38.922C62.2933 39.0004 62.0334 39.1622 61.7883 39.4073C61.5432 39.6525 61.3765 39.9172 61.2882 40.2016C61.2098 40.4859 61.2024 40.758 61.2662 41.0179C61.3348 41.2826 61.4623 41.5081 61.6486 41.6944C61.8398 41.8856 62.0653 42.018 62.3251 42.0915C62.5899 42.1602 62.8595 42.1553 63.1341 42.0768C63.4135 41.9935 63.6783 41.8268 63.9283 41.5767ZM70.0038 47.4758C69.8567 47.6229 69.7146 47.7454 69.5773 47.8435L66.599 44.8651C66.3293 45.1838 66.2019 45.5172 66.2166 45.8653C66.2313 46.2134 66.371 46.5198 66.6357 46.7845C67.0181 47.1669 67.4545 47.2748 67.9447 47.1081L69.0552 48.2185C68.5453 48.4931 67.9962 48.5911 67.4079 48.5127C66.8245 48.4293 66.2901 48.145 65.8047 47.6596C65.4125 47.2674 65.1453 46.8286 65.0032 46.3433C64.8708 45.8579 64.8757 45.3677 65.0179 44.8725C65.165 44.3822 65.4469 43.9287 65.8636 43.512C66.2852 43.0904 66.7411 42.806 67.2314 42.659C67.7217 42.5119 68.207 42.507 68.6875 42.6443C69.1679 42.7815 69.6092 43.0512 70.0112 43.4532C70.3985 43.8405 70.6608 44.2695 70.798 44.7401C70.9402 45.2157 70.9402 45.6912 70.798 46.1668C70.6657 46.6423 70.4009 47.0787 70.0038 47.4758ZM69.2317 46.1153C69.4915 45.8457 69.6067 45.5393 69.5773 45.1961C69.5528 44.848 69.4057 44.5391 69.1361 44.2695C68.8811 44.0145 68.587 43.8773 68.2536 43.8577C67.93 43.838 67.6114 43.9459 67.2976 44.1812L69.2317 46.1153ZM77.9852 52.6186C77.7107 52.8931 77.3871 53.0843 77.0145 53.1922C76.6468 53.3049 76.2497 53.2951 75.8232 53.1627C75.4015 53.0353 74.9799 52.7607 74.5583 52.3391L73.6979 51.4787L71.727 53.4495L70.6975 52.42L75.8305 47.287L77.7205 49.1769C78.1176 49.574 78.3872 49.981 78.5294 50.3977C78.6716 50.8144 78.6912 51.2115 78.5882 51.589C78.4902 51.9714 78.2892 52.3146 77.9852 52.6186ZM75.3452 51.464C75.6295 51.7483 75.9041 51.8954 76.1688 51.9052C76.4384 51.9101 76.6909 51.7949 76.9262 51.5596C77.4263 51.0595 77.3969 50.53 76.838 49.9712L76.0217 49.1549L74.5289 50.6477L75.3452 51.464ZM79.8003 54.6396C80.1484 54.5563 80.4892 54.5587 80.8225 54.647C81.1608 54.7401 81.4672 54.924 81.7418 55.1985L80.6608 56.2795L80.3887 56.0074C80.0651 55.6839 79.744 55.5147 79.4253 55.5C79.1115 55.4902 78.7659 55.6741 78.3884 56.0516L76.3587 58.0812L75.3292 57.0517L79.4032 52.9776L80.4328 54.0072L79.8003 54.6396ZM84.3725 61.8444C84.2254 61.9915 84.0832 62.1141 83.9459 62.2121L80.9676 59.2338C80.698 59.5525 80.5705 59.8858 80.5852 60.2339C80.5999 60.582 80.7396 60.8884 81.0044 61.1532C81.3868 61.5356 81.8231 61.6434 82.3134 61.4767L83.4238 62.5872C82.9139 62.8617 82.3648 62.9598 81.7765 62.8813C81.1931 62.798 80.6587 62.5136 80.1734 62.0283C79.7812 61.6361 79.514 61.1973 79.3718 60.7119C79.2394 60.2266 79.2443 59.7363 79.3865 59.2411C79.5336 58.7509 79.8155 58.2974 80.2322 57.8807C80.6538 57.459 81.1098 57.1747 81.6 57.0276C82.0903 56.8805 82.5757 56.8756 83.0561 57.0129C83.5366 57.1502 83.9778 57.4198 84.3798 57.8218C84.7671 58.2091 85.0294 58.6381 85.1667 59.1088C85.3089 59.5843 85.3089 60.0599 85.1667 60.5354C85.0343 61.011 84.7696 61.4473 84.3725 61.8444ZM83.6003 60.4839C83.8601 60.2143 83.9753 59.9079 83.9459 59.5647C83.9214 59.2166 83.7743 58.9078 83.5047 58.6381C83.2498 58.3832 82.9556 58.2459 82.6222 58.2263C82.2987 58.2067 81.98 58.3145 81.6662 58.5499L83.6003 60.4839ZM85.8036 65.6289L89.9586 63.533L91.0543 64.6287L85.4727 67.1952L84.2226 65.9451L86.7964 60.3708L87.8995 61.4739L85.8036 65.6289ZM92.7977 65.4013C92.6163 65.2199 92.5207 65.0116 92.5109 64.7763C92.5109 64.5409 92.5967 64.3375 92.7682 64.1659C92.9398 63.9943 93.1408 63.9109 93.3713 63.9158C93.6115 63.9207 93.8223 64.0139 94.0037 64.1953C94.1851 64.3767 94.2758 64.5851 94.2758 64.8204C94.2856 65.0557 94.2047 65.2592 94.0331 65.4308C93.8615 65.6023 93.6556 65.6857 93.4154 65.6808C93.185 65.6759 92.9791 65.5827 92.7977 65.4013ZM92.8197 66.3941L88.7457 70.4682L87.7161 69.4386L91.7902 65.3646L92.8197 66.3941ZM95.833 73.3049C95.6859 73.452 95.5437 73.5746 95.4065 73.6726L92.4281 70.6943C92.1585 71.013 92.031 71.3463 92.0457 71.6944C92.0604 72.0425 92.2002 72.3489 92.4649 72.6137C92.8473 72.9961 93.2836 73.1039 93.7739 72.9372L94.8843 74.0477C94.3745 74.3222 93.8254 74.4203 93.2371 74.3418C92.6536 74.2585 92.1193 73.9741 91.6339 73.4888C91.2417 73.0966 90.9745 72.6578 90.8323 72.1724C90.7 71.6871 90.7049 71.1968 90.847 70.7017C90.9941 70.2114 91.276 69.7579 91.6927 69.3412C92.1144 68.9196 92.5703 68.6352 93.0606 68.4881C93.5508 68.3411 94.0362 68.3361 94.5166 68.4734C94.9971 68.6107 95.4383 68.8803 95.8403 69.2824C96.2276 69.6697 96.4899 70.0986 96.6272 70.5693C96.7694 71.0448 96.7694 71.5204 96.6272 71.9959C96.4948 72.4715 96.2301 72.9078 95.833 73.3049ZM95.0608 71.9445C95.3207 71.6748 95.4359 71.3684 95.4065 71.0252C95.3819 70.6771 95.2349 70.3683 94.9652 70.0986C94.7103 69.8437 94.4161 69.7064 94.0827 69.6868C93.7592 69.6672 93.4405 69.7751 93.1267 70.0104L95.0608 71.9445ZM104.339 77.913L99.0732 80.7957L97.9628 79.6853L100.066 76.0966L96.4773 78.1998L95.3595 77.082L98.2349 71.8093L99.2791 72.8535L96.8965 76.6776L100.779 74.3537L101.868 75.4421L99.5365 79.3029L103.353 76.9276L104.339 77.913Z" fill="white"/>
        <path d="M44.8919 19.9407L39.4552 19.8353C39.0526 19.8275 38.7198 19.4946 38.7117 19.0918L38.6575 16.2852C38.6497 15.8824 38.9699 15.5622 39.3727 15.57C39.7755 15.5778 40.1084 15.9106 40.1163 16.3133L40.1565 18.391L44.8636 18.4821C45.2664 18.4899 45.5992 18.8228 45.6071 19.2255C45.6149 19.6281 45.2947 19.9483 44.8919 19.9407Z" fill="white"/>
        <path d="M47.4003 12.7611L47.2619 14.5739C47.2078 15.2816 47.4941 15.9727 48.0327 16.4349L49.4124 17.6188C49.7579 17.9152 49.7579 18.4499 49.4124 18.7463L48.0327 19.9302C47.4941 20.3924 47.2078 21.0835 47.2619 21.7912L47.4003 23.6039C47.435 24.0579 47.057 24.4359 46.6031 24.4012L44.7903 24.2628C44.0826 24.2087 43.3915 24.495 42.9293 25.0336L41.7454 26.4133C41.449 26.7588 40.9143 26.7588 40.6179 26.4133L39.434 25.0336C38.9718 24.495 38.2807 24.2087 37.573 24.2628L35.7602 24.4012C35.3063 24.4359 34.9283 24.0579 34.963 23.6039L35.1014 21.7912C35.1555 21.0835 34.8692 20.3924 34.3306 19.9302L32.9508 18.7463C32.6054 18.4499 32.6054 17.9152 32.9508 17.6188L34.3306 16.4349C34.8692 15.9727 35.1555 15.2816 35.1014 14.5739L34.963 12.7611C34.9283 12.3072 35.3063 11.9292 35.7602 11.9638L37.573 12.1023C38.2807 12.1564 38.9718 11.8701 39.434 11.3315L40.6179 9.95174C40.9143 9.60626 41.449 9.60626 41.7454 9.95174L42.9293 11.3315C43.3915 11.8701 44.0826 12.1564 44.7903 12.1023L46.6031 11.9638C47.057 11.9292 47.435 12.3072 47.4003 12.7611Z" stroke="white" strokeWidth="1.48571"/>
        </svg>
      );
    }

    function renderInformationIcon() {
      return (
      <svg style={{marginRight: '13.5px'}} width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1074 19.7148C16.2754 19.7148 20.4648 15.5254 20.4648 10.3574C20.4648 5.18946 16.2754 1 11.1074 1C5.93946 1 1.75 5.18946 1.75 10.3574C1.75 15.5254 5.93946 19.7148 11.1074 19.7148Z" stroke="#13BCB4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.1074 6.19824H11.118" stroke="#13BCB4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.0684 10.3574H11.1081V14.5163H12.1478" stroke="#13BCB4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      );
    }

    function renderSignupOnly() {
      return (
        <React.Fragment>
          <LoginForm formStyle={{height: '215px', minWidth: '334px'}} onSuccess={() => updateCurrentViewsState(VERIFY_CODE_STEP)} onCompletion={completeSignup} actionType='signup' buttonText={'Signup with email'} questionAnswer={selectedAnswer.value} acceptedTerms={acceptedTerms}>
        {false && renderAccountTypeQuestion()}
       </LoginForm >
        </React.Fragment>
      );
    }

    function renderSignupWithPreview() {
      return (
        <div className={style.signupWithPreviewContainer}>
          <div className={style.signupWithPreviewInnerContainer}>
          <div style={{display: 'flex', alignItems: 'center', position: 'relative', left: '1.5vw', bottom: '2vw'}}>
          <LoginForm formStyle={{height: '335px', position: 'relative', left: '20px', minWidth: '334px'}} onSuccess={() => updateCurrentViewsState(VERIFY_CODE_STEP)} onCompletion={completeSignup} actionType='signup' buttonText={'Signup with email'} questionAnswer={selectedAnswer.value} acceptedTerms={acceptedTerms}>
         </LoginForm >
         <div className={style.CustomPagePreviewWrapper}>
         {loadPreview()}
         <div style={{position: 'relative'}}>
         <img className={style.snapshotPreviewImage} src={previewSnapshotScreenshotImage}/>
         {renderPreviewBadge()}
         </div>

         </div>
          </div>
          <div className={style.signupNote}>
            {renderInformationIcon()}
            <span onClick={() => updateShowSignupNoteTooltip(true)} className={style.signupWithPreviewFooter}>Why do I need to signup?</span>
            <StyledToolTip tooltipStyle={{position: 'absolute', top: '-120px', height: '107px', width: '303px', minHeight: '0', right: '320px', border: "1.41506px solid #E1E1E1"}}
         show={showSignupNoteTooltip} shouldRenderPointer={true} pointerStyle={{left: 'unset', right: '80px', top: '33%', transform: 'rotate(-90deg)'}} fadeOut={false}>
           <span ref={signupNoteRef} className={style.signupNoteText}>
           We need your signup to <br/> save your custom page <br/> and user preferences
             </span>
        </StyledToolTip>
          </div>
          </div>
        </div>
      );
    }

    function renderWorkTypeOption(workType) {
      return (
        <div className={style.workTypeOptionContainer}>
          {workTypeSelectedOptions.includes(workType) ? renderSelectedCheckbox(() => updateWorkTypeSelectedOptions(workTypeSelectedOptions.filter(i => i != workType))) : renderEmptyCheckbox(() => updateWorkTypeSelectedOptions([...workTypeSelectedOptions, workType]))}
          <span className={style.workTypeOptionText}>{workType}</span>
        </div>
      );
    }

    function renderWorkTypeQuestionForm() {
      let canContinue = workTypeSelectedOptions.length > 0 || otherWorkTypeText;
      let eventData = {from_step: VERIFY_CODE_STEP, to_step: WORK_TYPE_QUESTION_STEP, user_email: '', is_work_email: false};
      utils.trackFormStepChanged(eventData);
      return (
        <div className={style.workTypeQuestionContainer}>
          <span className={style.workTypeQuestionTitle}>What best describes what you do?</span>
          <div className={style.workTypeQuestionOptions}>
            {workTypes.map((workType) => {
              return renderWorkTypeOption(workType);
            })}
          </div>
          <textarea value={otherWorkTypeText} onChange={(e) => updateOtherWorkTypeText(e.target.value)} className={style.otherWorkOption} placeholder='Other (Please shortly describe your work)'/>
          <button disabled={!canContinue}
          className={canContinue ? style.WorkTypeQuestionContinueButton : style.WorkTypeQuestionContinueButtonDisabled}
          onClick={() => {
            let answersToSend = otherWorkTypeText ? [...workTypeSelectedOptions, otherWorkTypeText] : workTypeSelectedOptions;
            utils.trackEvent(consts.TRACKING_CATEGORY.WORK_TYPE, 'work_types_answered','work_types', JSON.stringify(answersToSend));
            onBrandSkipClick();
            //updateCurrentViewsState(ADD_BRAND_CTA);
          }}
          >
            Continue
            </button>
          <span onClick={() => onBrandSkipClick()} className={style.workTypeQuestionSkip}>Skip</span>
        </div>
      );
    }

   const memoizedCustomizeSectionsSmall = useMemo(() => renderCustomizeSectionsSmall(), [acceptedTerms]);

    function renderViewByState() {
      switch (currentViewState) {
        case FILL_DETAILS_STEP:
        case VERIFY_CODE_STEP:
          return renderSignupOnly();
          //return renderSignupWithPreview();
        case WORK_TYPE_QUESTION_STEP:
          return renderWorkTypeQuestionForm();  
        case ADD_BRAND_STEP:
          return memoizedCustomizeSectionsSmall;
        case PREVIEW_BRAND_STEP:
          return <React.Fragment>
            <CustomPagePreview EditCoverPhotoOnHover={true}
             customPagePreviewStyle={{top: '0', right: '0', display: 'block', marginLeft: 'auto', marginRight: 'auto',
             overflow: 'hidden', minHeight: '372px', height: '40vh', maxHeight: '550px', width: '34.4vw',
             minWidth: '615px', marginTop: '30.9px', filter: 'drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.4400691))'}}
             siteTemplate={siteTemplate} applyInitialStyle={true}
             currentActiveTab={consts.TAB_NAMES.Brand_Your_Site}
             LoaderOverlayStyle={{borderRadius: '0'}}
             LoaderText={'Creating Your Page...'}
             coverImageStyle={{maxHeight:'min(23vh, 140px)'}}
             hideDefaultText={true}
             />
            {renderCompletionFooter()}
          </React.Fragment>
          case ADD_BRAND_CTA:
            return renderAddBrandCtaPage();
        default:
          break;
      }
    }

    function renderStarIcon() {
      return (
        <svg className={style.starIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
        <path d="M10.0063 15.0955L4.44372 18L5.50631 11.8482L1 7.49192L7.21871 6.59685L10 1L12.7813 6.59685L19 7.49192L14.4937 11.8482L15.5563 18L10.0063 15.0955Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      );
    }

    function onAddBrandClick() {
      let eventData = {from_step: ADD_BRAND_CTA, to_step: ADD_BRAND_STEP, user_email: '', is_work_email: false};
      utils.trackFormStepChanged(eventData);
      updateCurrentViewsState(ADD_BRAND_STEP);
    }

    async function onBrandSkipClick() {
       dispatch({ type: 'LOADING-CHANGED', payload: true}); 
       await restUtils.post('completeOnboarding', null, true, config.NETWORK_REQUEST_TIME_OUT);
       dispatch({ type: 'LOADING-CHANGED', payload: false}); 
       window.location.assign('/');
    }

    function renderAddBrandCtaPage() {
      let eventData = {from_step: WORK_TYPE_QUESTION_STEP, to_step: ADD_BRAND_CTA, user_email: '', is_work_email: false};
      utils.trackFormStepChanged(eventData);
      return(
        <div className={style.addBrandCtaWrapper}>
        <div className={style.addBrandCtaContainer}>
          <div className={style.addBrandCtaContentWrapper}>
          <div className={style.addBrandCtaContent}>
           <img className={style.brandPreviewImage} src={'/images/brandCtaPreviewForm.png'}/>
           <div className={style.addBrandCtaRight}>
           <span className={style.addBrandCtaTextBold}>Now, let’s create <br/> your download page!</span>
           <span className={style.addBrandCtaText}>Impress your recipients with your custom download page. <br/>
           Choose your colors, add a <br/> cover photo and text and <br/> make it your own!</span>
           <button onClick={onAddBrandClick} className={style.addBrandButton}>Create Your Page</button>
           <span onClick={onBrandSkipClick} className={style.skipBrand}>Skip this step</span>
         </div>
          </div>
          </div>
        </div>
        </div>
      );
    }

    return (
      <React.Fragment>
      {loading && (currentViewState === VERIFY_CODE_STEP || currentViewState === FILL_DETAILS_STEP || currentViewState === WORK_TYPE_QUESTION_STEP) && <LoaderOverlay LoaderOverlayStyle={{zIndex: '2000'}}>
      <span className={style.loaderText}>{currentViewState === FILL_DETAILS_STEP ? 'Creating your profile' : 'Creating your page...'}</span>
      <span className={style.loaderTextSubHeadline}>It might take a few moments, please don't close this page.</span>
      </LoaderOverlay>}
      <Layout>
        <Header/>
      </Layout>
      <div style={{filter: loading && 'blur'}} className={style.signUpContainer}>
      <div style={{display: 'block',  marginTop: '-3vh'}}>
      <h1 className={style.signupTitle}>{getHeaderTextByStep()}</h1>
      {SHOW_STEPPER && <Stepper show={currentViewState != ADD_BRAND_STEP && currentViewState != PREVIEW_BRAND_STEP} steps={steps} stepperStyle={{marginBottom: '60px', marginTop: '25px'}}/>}
      <div className={style.descriptionContainer}>
        {currentViewState === PREVIEW_BRAND_STEP && renderStarIcon()}
        <span className={getDescriptionClassByStep()}>{getDescriptionTextByStep()}</span>
        <div ref={wrapperRef} style={{height: '0'}}>
        <StyledToolTip tooltipStyle={{position: 'absolute', top: '-105px', height: '388px', right: 'calc(100% - min(750px, 39vw))', border: "1.41506px solid #E1E1E1"}}
         show={showOptionalPageInfo && currentViewState === PREVIEW_BRAND_STEP} shouldRenderPointer={true} pointerStyle={{right: '-69px', left: 'unset', top: '11%', transform: 'rotate(180deg)'}} fadeOut={false}>
           <CustomizeSectionsSmall hideSkip hideTitles containerStyle={{boxShadow: 'none', width: '100%'}}
           contentStyle={{paddingTop: '0', marginRight: '0', marginLeft: '0'}}
           inputStyle={{width: '216px', display: 'block', marginLeft: 'auto', marginRight: 'auto'}}
           inputContainerStyle={{marginLeft: 'auto', marginRight: 'auto'}}
           ChangeBackgroundButtonStyle={{filter: 'unset', marginTop: '0', height: '42px', borderRadius: '3.5px', border: 'none', marginBottom: '18px'}}
           buttonText={'Done'}
           buttonStyle={{width: '132px'}}
           onButtonClick={() =>  updateShowOptionalPageInfo(false)}
           />
        </StyledToolTip>
        </div>
      </div>
      {renderViewByState()}
      {currentViewState === FILL_DETAILS_STEP && <React.Fragment>
      {false && <span className={style.login}>Already have an account?
      <Link href="/posts/login">
      <a className={style.loginLink}>Log in</a>
      </Link>
      </span>}
      <span className={style.recaptchaTerms}>This site is protected by reCAPTCHA and the <br/>
      Google <a target="_blank" rel="noopener noreferrer" href={'https://policies.google.com/privacy'} className={style.termsLink}>Privacy Policy</a> and  <a target="_blank" rel="noopener noreferrer" href='https://policies.google.com/terms' className={style.termsLink}>Terms of Service</a> apply.
      </span>
      </React.Fragment> }
      </div>
      </div>
      </React.Fragment>
    );
  }